// extracted by mini-css-extract-plugin
export default {"mainContainer":"UploadBranches_mainContainer__V4BIz","uploadBranchesFileContainer":"UploadBranches_uploadBranchesFileContainer__ahMse","title":"UploadBranches_title__AfgI4"};